module.exports = __webpack_public_path__ + "4424d29089fa57351b0457d5f71f3047.png";